import React from "react";
import {
  MeetingProvider,
  NotificationProvider,
  lightTheme,
  darkTheme,
} from "amazon-chime-sdk-component-library-react";
import { useDispatch, useSelector } from "react-redux";

import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import {
  USERLIST,
  SCHEDULE,
  GENERAL,
  CHAT,
  routes,
  TRACKER,
  STATORDER,
  HOME,
  ROUTINEREDRAW,
  FACILITYLIST,
  LABLIST,
  HOSPITALLIST,
  TIMEDDRAW,
  HOMEHEALTH,
  TERRITORYLIST,
  ZONELIST,
  USER_GUIDE,
  ROLE_ADMIN,
  ROLE_SUPER_ADMIN,
  SEARCH,
  CARE_AT_HOME_SCHEDULE,
} from "../../app/utils/Constants";
import Chat from "../../features/Chat/Chat";
import Authenticated from "../../features/Chat/components/Authenticated";
import Notifications from "../../features/Chat/containers/Notifications";
import {
  AppStateProvider,
  useAppState,
} from "../../features/Chat/providers/AppStateProvider";
import { AuthProvider } from "../../features/Chat/providers/AuthProvider";
import { MessagingProvider } from "../../features/Chat/providers/ChatMessagesProvider";
import IdentityProvider from "../../features/Chat/providers/IdentityProvider";
import { NavigationProvider } from "../../features/Chat/providers/NavigationProvider";
import { UserPermissionProvider } from "../../features/Chat/providers/UserPermissionProvider";
import Channels from "../../features/Chat/views/Channels";
import ChannelsAdmin from "../../features/Chat/adminviews/Channels";
import Signin from "../../features/Chat/views/Signin";
import Home from "../../features/LandingPage/Home";
import { Scheduler } from "../../features/Scheduler/scheduler";
import { Tracker } from "../../features/Tracker/tracker";
import ScheduleComponent from "../commons/SchedulerComponent";
import AdminLayout from "../layouts/AdminLayout";
import {
  validSessionDataForLogin,
  validSessionForLogin,
} from "../../appSliceForLogin";
import StatOrder from "../../features/StatOrder";
import { MobileView } from "../../features/Mobile";
import { UserGuide } from "../../features/UserGuide/userGuide";
import { GlobalSearch } from "../../features/GlobalSearch/globalSearch";
import { HomeHealthCalendar } from "../../features/HomeHealthScheduler/homeHealthCalendar";

export default function PrivateRoute(props) {
  const { isMobile } = props;
  const dispatch = useDispatch();
  const history = useHistory();

  const validSessionResponse = useSelector(validSessionDataForLogin);

  const hasUserData =
    window.localStorage.getItem("userData") &&
      JSON.parse(window.localStorage.getItem("userData")).access_token
      ? true
      : false;

  let roles =
    (window.localStorage.getItem("userDetail") &&
      JSON.parse(window.localStorage.getItem("userDetail")).roles &&
      JSON.parse(window.localStorage.getItem("userDetail")).roles) ||
    [];

  let canViewAdminChat = roles && (roles.includes(ROLE_ADMIN) || roles.includes(ROLE_SUPER_ADMIN));

  React.useEffect(() => {
    hasUserData && dispatch(validSessionForLogin());
  }, []);

  React.useEffect(() => {
    if (validSessionResponse) {
      if (
        validSessionResponse.status &&
        validSessionResponse.status === "SUCCESS"
      ) {
        history.push(
          window.location.pathname === "/" || window.location.pathname === ""
            ? TRACKER
            : `${window.location.pathname}${window.location.search}`
        );
      }
    }
  }, [validSessionResponse]);

  return (
    <AppStateProvider>
      <Theme>
        <NotificationProvider>
          <Notifications />
          <MeetingProvider>
            <AuthProvider>
              {window.location.pathname &&
                window.location.pathname.includes("chats") && <Authenticated />}
              <IdentityProvider>
                <NavigationProvider>
                  <MessagingProvider>
                    <UserPermissionProvider>
                      <AdminLayout>
                        {isMobile ? (
                          <Switch>
                            <Route exact path={"/"} component={MobileView} />
                            <Redirect to={"/"} component={MobileView} />
                          </Switch>
                        ) : (
                          <Switch>
                            <Route exact path={USERLIST} component={Home} />
                            <Route exact path={FACILITYLIST} component={Home} />
                            <Route exact path={LABLIST} component={Home} />
                            <Route exact path={HOSPITALLIST} component={Home} />
                            <Route exact path={TERRITORYLIST} component={Home} />
                            <Route exact path={ZONELIST} component={Home} />
                            <Route
                              exact
                              path={SCHEDULE}
                              component={Scheduler}
                            />
                            <Route
                              exact
                              path={CARE_AT_HOME_SCHEDULE}
                              component={HomeHealthCalendar}
                            />
                            <Route
                              exact
                              path={GENERAL}
                              component={ScheduleComponent}
                            />
                            <Route exact path={CHAT} component={Chat} />
                            <Route
                              exact
                              path={STATORDER}
                              component={StatOrder}
                            />
                            <Route
                              exact
                              path={ROUTINEREDRAW}
                              component={StatOrder}
                            />
                            <Route
                              exact
                              path={TIMEDDRAW}
                              component={StatOrder}
                            />
                            <Route
                              exact
                              path={HOMEHEALTH}
                              component={StatOrder}
                            />
                            <Route
                              exact
                              path={routes.SIGNIN}
                              component={Signin}
                            />
                            <Route exact path={routes.CHAT}>
                              <Channels />
                            </Route>
                            {canViewAdminChat && <Route exact path={routes.CHAT_ADMIN}>
                              <ChannelsAdmin />
                            </Route>}
                            <Route exact path={USER_GUIDE} component={UserGuide} />
                            <Route exact path={TRACKER} component={Tracker} />
                            <Route exact path={SEARCH} component={GlobalSearch} />
                            {/* <Redirect to={TRACKER} component={Home} /> */}
                          </Switch>
                        )}
                      </AdminLayout>
                    </UserPermissionProvider>
                  </MessagingProvider>
                </NavigationProvider>
              </IdentityProvider>
            </AuthProvider>
          </MeetingProvider>
        </NotificationProvider>
      </Theme>
    </AppStateProvider>
  );
}
const Theme = ({ children }) => {
  const { theme } = useAppState();

  return (
    <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
      {/* <GlobalStyles /> */}
      {children}
    </ThemeProvider>
  );
};
